import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ReactComponent as EmptyIcon } from 'Assets/img/empty.svg'
import PropTypes from 'prop-types'
import React from 'react'
import { When } from 'react-if'
import Button from 'Theme/Button'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

const NoContent = ({ onClear, text, textColor, sx }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
    sx={(theme) => ({
      paddingTop: theme.spacing(10),
      ...sx,
    })}
  >
    <EmptyIcon />
    <Box
      component={Typography}
      py={3}
      variant="body2"
      color={textColor || 'inheriet'}
      textAlign="center"
    >
      {text}
    </Box>
    <When condition={!!onClear}>
      <Button
        variant="text"
        color="inherit"
        onClick={onClear}
      >
        <FAIcon
          iconClassName={FA_ICONS.CLOSE}
          boxSize={12}
          sx={{ marginRight: '16px' }}
        />
        Clear request
      </Button>
    </When>
  </Box>
)

NoContent.propTypes = {
  text: PropTypes.string.isRequired,
  onClear: PropTypes.func,
}

export default NoContent
